import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_lengyel from "../../assets/img/face_balazs_lengyel.jpg";
import ShowMoreText from "react-show-more-text";
import proj_spatial_waves_of_knowledge from "../../assets/img/proj_spatial_waves_of_knowledge.png";

const Balazs_Lengyel_spatial_waves = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_spatial_waves_of_knowledge} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_lengyel}
              /* this will be the text on the banner */
              alt="Spatial waves of scientific knowledge"
            />{" "}
            <p className="text7">Balázs Lengyel</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            <p className="text8">HUN-REN Centre for Economic and Regional Studies </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Most scientific ideas have a life cycle; discoveries and new concepts may be 
            recognized widely but can also vanish. Although details about the concentration 
            of research excellence in global hubs are explored in detail, we understand 
            very little about where original ideas come from, how they spread across scientific 
            communities and, eventually, how they are forgotten. In this project, we are 
            going to use openly available data from publication records in the medical sciences. 
            This data enables us to trace spatial dynamics of idea adoption by following how 
            concepts appear in abstracts of the papers. Our aim will be to understand how major 
            organizations, individual scientists and their collaboration networks influence the 
            spatial rise and fall of ideas. We will explore geographies of adoption and decline 
            with gravity and urban scaling models. Then, differential equation and network science 
            techniques will be used to fit adoption and disadoption curves at global and local scales.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Lengyel_spatial_waves;